module.exports = __webpack_public_path__ + "static/media/hackathon.a6dd3923.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hackathon.jpg
// module id = 429
// module chunks = 0